import * as React from "react";
import styles from "./PageNavigation.module.scss";

type PageNavigationProps = {
    allowPrevious: boolean;
    allowNext: boolean;
    useSubmitForNext: boolean;
    onPrevious?: () => void;
    onNext?: () => void;
}

const PageNavigation : React.FunctionComponent<PageNavigationProps> = (props) => {
    return <footer className={styles.wrapper}>
        <button type="button" className={styles.button} disabled={!props.allowPrevious} onClick={props.onPrevious}>Previous</button>
        <button type="button" className={styles.button} disabled={!props.allowNext} onClick={props.onNext}>{props.useSubmitForNext ? "Submit" : "Next"}</button>
    </footer>;
}

export default PageNavigation;